module.exports = __webpack_public_path__ + "img/halfcut-bg.e8a5aaea.svg";